import { render, staticRenderFns } from "./FormAddDocs.vue?vue&type=template&id=09912ce2&"
import script from "./FormAddDocs.vue?vue&type=script&lang=js&"
export * from "./FormAddDocs.vue?vue&type=script&lang=js&"
import style0 from "./FormAddDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports